
import React from 'react';
import './Testimonials.css';

function Testimonials() {
  return (
    <section className="testimonials-section">

      <div className="testimonials-container">

        <div className="testimonials-header">

          <p>CLIENT REVIEWS</p>

          <h2>What Our Customers Say</h2>

          <span>
            We pride ourselves on delivering professional,
            reliable and high-quality cleaning services.
          </span>

        </div>

        <div className="testimonials-grid">

          <div className="testimonial-card">

            <div className="stars">
              ★★★★★
            </div>

            <p>
              “Excellent service. My car looked brand new again.
              Very professional and reliable team.”
            </p>

            <div className="client-info">
              <h4>James M.</h4>
              <span>Muizenberg</span>
            </div>

          </div>

          <div className="testimonial-card">

            <div className="stars">
              ★★★★★
            </div>

            <p>
              “Their house cleaning service was amazing.
              Very detailed and professional.”
            </p>

            <div className="client-info">
              <h4>Sarah K.</h4>
              <span>Muizenberg</span>
            </div>

          </div>

          <div className="testimonial-card">

            <div className="stars">
              ★★★★★
            </div>

            <p>
              “Very reliable Airbnb cleaning and reset service.
              Highly recommended.”
            </p>

            <div className="client-info">
              <h4>Daniel R.</h4>
              <span>Lakeside</span>
            </div>

          </div>

        </div>

      </div>

    </section>
  );
}

export default Testimonials;

